<template>
  <el-dialog
    :close-on-click-modal="false"
    title="上传要求"
    :visible.sync="dialogVisible"
    class="small-dialog"
    v-dialogDrag
  >
    <p class="text-base text-center font-bold mb-10px">
      人脸照片<span class="text-red-500">采集标准</span>要求说明
    </p>
    <div>
      <p class="font-bold mb-10px">一、照片示例</p>
      <div class="flex">
        <img
          class="inline-block w-200px h-180px ml-10px"
          src="@/assets/images/example/example1.png"
          alt=""
        />
        <img
          class="inline-block w-200px h-180px ml-10px"
          src="@/assets/images/example/example2.png"
          alt=""
        />
      </div>
    </div>
    <div class="mt-10px">
      <p class="font-bold mb-10px">二、详细说明</p>
      <div class="pl-10px">
        <p>1.露出额头及耳朵，人脸正面免冠，近期大头照</p>
        <p>2.照片白底，无逆光，无PS，无过度美颜处理</p>
        <p>3.照片保存为JPG格式，大小约150-200KB，（可用画图软件调整像素为640*480或以上）</p>
        <p>4.两眼之间像素点大于60</p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
}
</script>

<style></style>
